import  React, { FC } from 'react';

import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import FontIcon from 'Src/components/icons/FontIcon';
import { Flex } from 'Src/components/layout/Flex';

import styles from './FlipAndTipReceiptToast.module.scss';

type FlipAndTipReceiptToastProps = {
    doneLabel: string,  
    title: string,
    message: string,
    onDone: () => void
}

const FlipAndTipReceiptToast: FC<FlipAndTipReceiptToastProps> = ({ doneLabel, title, message, onDone }) => (
  <Flex
    horizontal
    alignItems="center"
    justifyContent="space-between"
    gap="sm"
    padding="lg"
    className={styles.root}
  >
    <Flex
      horizontal
      alignItems="center"
      gap="lg"
    >
      <FontIcon size="sm" name="email" />
      <Flex gap="none" >
        <Copy variant="body" weight="semi-bold">{title}</Copy>
        <Copy variant="body">
          {message}
        </Copy>
      </Flex>
    </Flex>
    <div>
      <CTA size="xs" label={doneLabel} variant="default" color="secondary" onClick={onDone} />
    </div>
  </Flex>
);

export { FlipAndTipReceiptToast };
